import { SETTINGS_TAG_KEYS } from '../../lib/permissionCatalog/settingsPageKeys';
import type { TagEntityType } from '../../lib/tags/types';

/**
 * The entity types whose tags Settings manages, each on its own page (`/settings/tags/<type>`) opened from
 * its own card on the Settings page (design-system §8, Rev 70), in the order the cards show them. `deal` is
 * not offered: the CRM has no deal tags; *Deal tags* belong to F2-a (F1-e spec FR-H1).
 */
export const TAG_SETTINGS_TYPES = ['account', 'contact', 'lead'] as const satisfies readonly TagEntityType[];

export type TagSettingsType = (typeof TAG_SETTINGS_TYPES)[number];

/** Each type's page title and card title. */
export const TAG_SETTINGS_TITLES = {
    account: 'Account tags',
    contact: 'Contact tags',
    lead: 'Lead tags',
} as const satisfies Readonly<Record<TagSettingsType, string>>;

/** Each type's page key (AD #41): its route, its card and its row in the role editor's Settings pages. */
export const TAG_SETTINGS_KEYS = SETTINGS_TAG_KEYS satisfies Readonly<Record<TagSettingsType, string>>;
